import React from "react";
import { Link } from "react-router-dom";

const NoItems = () => {
	return (
		<div className='p-20 border-4'>
			<h1 className=' capitalize   text-center text-2xl'>No Items in the cart</h1>
			<div>
				<Link to='/'>
					<button className='mx-auto mt-5 rounded text-white w-36 py-2 px-5 bg-custom-blue block '>Back To Home</button>
				</Link>
			</div>
		</div>
	);
};

export default NoItems;
